$(document).ready(function () {

    // Mob_menu
    $('.mob_hamburger').click(function () {
        $('.header_bottom, body').addClass('active_menu');
        $('body').addClass('overflow-hidden');
    });
    $('.close_menu').click(function () {
        $('.header_bottom, body').removeClass('active_menu');
        $('body').removeClass('overflow-hidden');
    });

    // Home-FAQ
    $('body').on('click', '.accordian_title', function (e) {
        e.preventDefault()
        $(this).closest('.accordian_ul_wrp').find(".accordian_title.active").next().slideUp();
        $(this).closest('.accordian_ul_wrp').find(".accordian_info").removeClass("active");
        $(this).closest('.accordian_ul_wrp').find(".accordian_title").removeClass("active");
        if (!$(this).next().is(":visible")) {
            $(this).next().slideDown();
            $(this).addClass("active");
            $(this).closest('.accordian_info').toggleClass('active');
        }
    });

    // hero_banner_slider
    var swiper = new Swiper(".hero_banner_slider", {
        slidesPerView: 1,
        draggable: true,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
    });

    // collection filter

    $('body').on('click', '.filter_cat', function (e) {
        //e.preventDefault()
        if ($(this).hasClass('active')) {
            $(this).next().slideUp();
            $(this).removeClass("active");
        } else if (!$(this).next().is(":visible")) {
            if ($('body').find('.filter_cat.active').length) {
                $('body').find('.filter_cat.active').next().slideUp();
                $('body').find('.filter_cat.active').removeClass('active');
            }
            $(this).next().slideDown();
            $(this).addClass("active");
        }
    });

    // COLLECTION
    $('body').find('.collection_menu_icon').click(function () {
        $('.product_grid').toggleClass('hide_menu');
        if ($(window).width() < 768) {
            $('body').toggleClass('overflow-hidden');
        }
    });

    $('body').on('click', '.close_filter', function () {
        $('.product_grid').removeClass('hide_menu');
        $('body').removeClass('overflow-hidden');
    });

    // pdp-Qty
    $('body').on('click', '.incremant-spinner .btn', function (e) {
        e.preventDefault;
        var input = $(this).closest('.incremant-spinner').find('input.quantity');
        var ip = parseInt(input.val());
        if ($(this).hasClass('quantity-increment')) {
            ip = ip + 1;
        } else {
            ip = ip - 1;
        }
        if (ip == 0) {
            return false;
        }
        input.attr('value', ip);
    });

    //collection custome_dropdown_select
    $('body').on('click', '.custome_dropdown_select', function () {
        $(this).toggleClass('open');
    });
    $('body').on('click', '.custome_dropdown_select .list li', function () {
        var itemValue = $(this).data('value');
        $('.custome_dropdown_select .list li').removeClass('selected');
        //console.log(itemValue);
        $('.custome_dropdown_select span').text($(this).text()).parent().attr('data-value', itemValue);
        $(this).toggleClass('selected');
    });

    // nutripedia_popup
    $('body').on('click', '.logo_fix', function (e) {
        e.preventDefault()
        $('.np_popup').toggleClass('active');
        $('body').toggleClass('overflow-hidden');
    });

    // login_popup
    $('body').on('click', '.account_wrp .login_icon', function (e) {
        e.preventDefault();
        $('.account_wrp').toggleClass('active_popup');
        if ('.account_wrp.active_popup'.length) {
            $('body').addClass('overflow-hidden');
        } else {
            $('body').removeClass('overflow-hidden');
        }
    });

    // mini_cart
    $('body').on('click', '.cart-wrp .cart_icon_wrp', function (e) {
        e.preventDefault();
        if ($('.mini_cart').length) {
            $('.cart-wrp').addClass('cart_active');
            $('body').addClass('overflow-hidden');
        }
    });
    $('body').on('click', '.mini_cart_wrp .close_cart', function (e) {
        e.preventDefault();
        $('.cart-wrp').removeClass('cart_active');
        $('body').removeClass('overflow-hidden');
    });

    // credits popup 
    $('#credits-lnk').on('click', function (e) {
        e.preventDefault();
        console.info('credits-lnk clicked!');
        $('#popup').fadeIn();
    });

    $('.close-btn').on('click', function () {
        $('#popup').fadeOut();
    });

    // Close the popup when clicking outside the content
    $(window).on('click', function (event) {
        if ($(event.target).is('#popup')) {
            $('#popup').fadeOut(); // Hide the popup with a fade effect
        }
    });


    //overlay
    $('body').on('click', '.overlay', function () {
        if ($('.account_wrp.active_popup').length) {
            $('.account_wrp').removeClass('active_popup');
        } else if ($('.cart-wrp.cart_active').length) {
            $('.cart-wrp').removeClass('cart_active');
        } else if ($('.np_popup.active').length) {
            $('.np_popup').removeClass('active');
        } else if ($('.quick_search.active').length) {
            $('.quick_search').find('.search_input').val('');
            $('.quick_search').find('#predictive-search').css('display', 'none');
            $('.quick_search').removeClass('active');
        } else if ($('.product_grid.hide_menu').length) {
            $('.product_grid').removeClass('hide_menu');
        } else if ($('.notify-us-popup.active').length) {
            $('.notify-us-popup').removeClass('active');
        } else if ($('.notify-us-success.active').length) {
            $('.notify-us-success').removeClass('active');
        }
        $('body').removeClass('overflow-hidden');
    });
    //collection filter 

    $('body').on('click', '.custome_dropdown_select .list li', function (e) {
        var sort_val = $(this).attr('data-value');
        //console.log('sort_val=',sort_val);
        var old_sort_val = $('.custome-select').val();
        //console.log('old_sort_val=',old_sort_val);
        if (sort_val != old_sort_val) {
            $('.custome-select').val(sort_val).change();
            let filter_url = serialize_form($(this));
            setTimeout(function () {
                update_collection(filter_url);
            }, 300);
        }
    });

    $('body').on('click', '.rm_filter', function (e) {
        e.preventDefault();

        var $this = $(this);
        var $link = $this.find('a');

        // Check if element contains an anchor tag
        if ($link.length === 0) return;

        var new_url = $link.attr('href');

        // Check if URL is valid
        if (!new_url) return;

        setTimeout(function () {
            update_collection(new_url);
        }, 100);
    });

    $('body').on('change', '.radio-btn-block .filter_input, .price-block input[type="number"]', function () {
        let filter_url = serialize_form($(this));
        setTimeout(function () {
            update_collection(filter_url);
        }, 100);

    });

    function serialize_form(obj) {
        var form = obj.closest('form');
        var col_url = form.data("url");
        let form_data = form.find(':input')
            .filter(function () { return this.value !== ''; })
            .serialize();

        let new_url = col_url;
        if (form_data) {
            const separator = col_url.includes('?') ? '&' : '?';
            new_url += separator + form_data;
        }
        return new_url;
    }

    function update_collection(this_url) {
        $('html,body').animate({ scrollTop: $('.filter_form').offset().top - 10 }, 100);
        $('.pr_grid_wp_inner').empty();
        $('.loading_wrp').show();

        function applyResponse(data) {
            // $('<div>').html(data) safely handles both full-page HTML and section-only markup
            var $newForm = $('<div>').html(data).find('.filter_form');
            if ($newForm.length === 0) {
                return false;
            }
            window.history.pushState("", "", this_url);
            if (this_url.includes("collection")) {
                $('body').find('.filter_form').html($newForm.html());
                $('.product_grid').removeClass('hide_menu');
            }
            $('body').removeClass('overflow-hidden');
            return true;
        }

        // Try Section Rendering API first — returns just main-collection markup, much smaller
        var sectionUrl = this_url + (this_url.includes('?') ? '&' : '?') + 'section_id=main-collection';
        $.get(sectionUrl).done(function (data) {
            if (!applyResponse(data)) {
                // Section response didn't contain .filter_form — fall back to full page fetch
                $.get(this_url).done(applyResponse);
            }
        }).fail(function () {
            // Section URL failed entirely — fall back to full page fetch
            $.get(this_url).done(applyResponse);
        });
    }
    //pdp-form-sumbit
    $('body').on('click', '.add-to-basket,.add_cart_btn', function (e) {
        e.preventDefault();
        let this_obj = $(this);
        let form = $(this).closest('.pdp-right, .product_card');
        let KEY = form.find('.product_id').val();
        let QTY = form.find('.pdp_quantity').val();
        $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: {
                id: KEY,
                quantity: QTY
            },
            dataType: "json",
            beforeSend: function () {
                // setting a timeout
                this_obj.addClass('adding');
            },
            success: function (data) {
                update_mini_cart();
                $('input.quantity').attr('value', 1);
            },
            error: function (response) {
                $('input.quantity').attr('value', 1);
                alert(response.responseJSON.description);
            },
            complete: function () {
                this_obj.removeClass('adding');
            }
        });
    });

    //update mini cart
    function update_mini_cart() {
        $.get('/cart?view=mini-cart', function (data) {
            $('body').find('.mini_cart_wrp').html($(data).find('.mini_cart_wrp').html());
            $('body').find('.cart_item_count').html($(data).find('.cart_item_count').html());
        });
        window.scrollTo(0, 0);
        setTimeout(function () {
            $('.cart-wrp').addClass('cart_active');
            $('body').addClass('overflow-hidden');
        }, 500);
    }
    $('body').on('click', '.remove_product', function (e) {
        var line_key = $(this).attr('data-key');
        $.ajax({
            type: "POST",
            url: "/cart/change.js",
            data: {
                id: line_key,
                quantity: 0
            },
            dataType: "json",
            success: function (data) {
                $.get('/cart?view=mini-cart', function (data) {
                    $('body').find('.mini_cart_wrp').html($(data).find('.mini_cart_wrp').html());
                    $('body').find('.cart_item_count').html($(data).find('.cart_item_count').html());
                });
                window.scrollTo(0, 0);
            },
            error: function (response) {
                alert(response.responseJSON.message);
            }
        });
    });


    //cart page
    $('body').on('click', '.cart_refresh', function (e) {
        $(this).find('img').addClass('rotate');
        $('body').find('.cart_section .container').css('opacity', '0.6');
        var line_item = $(this).closest('.cart_table_row ');
        var line_key = line_item.data('id');
        var line_quantity = parseInt(line_item.find('.item_quantity').val());
        if (isNaN(line_quantity)) {
            console.log('nannn');
            line_quantity = 1;
        }
        $.ajax({
            type: "POST",
            url: "/cart/change.js",
            data: {
                id: line_key,
                quantity: line_quantity
            },
            dataType: "json",
            success: function (data) {
                console.log("successsssss");
                update_main_cart();
            },
            error: function (response) {
                alert(response.responseJSON.message);
                update_main_cart();
            }
        });
    });
    $('body').on('keydown', 'input[name="updates[]"]', function (e) {
        if (event.key == "Enter") {
            e.preventDefault();
            $(this).closest('.cart_table_quantity').find('.cart_refresh').trigger('click');
        }
    });

    function update_main_cart() {
        $.get('/cart', function (data) {
            $('body').find('.cart_section .container').html($(data).find('.cart_section .container').html());
            $('body').find('.cart_item_count').html($(data).find('.cart_item_count').html());
            $('body').find('.cart_section .container').css('opacity', '1');
        });
    }
    //home page scroll down
    $("body").on('click', '.scroll_more', function () {
        var target = $('.product_grid:eq(0)');
        if (target.length) {
            $('html,body').animate({
                scrollTop: target.offset().top
            }, 100);
            return false;
        }
    });
    //search box
    $('.search_input').on('change focus keyup', function () {
        if ($(this).val() !== '') {
            $(this).closest('form').find('.empty_input').addClass('active');
        } else {
            $(this).closest('form').find('.empty_input').removeClass('active');
        }
    });
    function clearSearch(obj) {
        obj.closest('predictive-search').find('#predictive-search').css('display', 'none');
        obj.closest('form').find('input[type=search]').val('');
        obj.removeClass('active');
        obj.closest('form').find('input[type=search]').attr('autofocus', 'autofocus').focus();
    }
    $('body').on('click', '.empty_input', function (event) {
        var $this = $(this);
        setTimeout(function () {
            clearSearch($this);
        }, 400);
    });

    //mobile search 
    $('body').on('click', '.search_icon.mobile', function () {
        if ($('.quick_search.active').length) {
            $('.quick_search').remove('active');
            $('body').removeClass('overflow-hidden');
        } else {
            $('.quick_search').addClass('active');
            $('body').addClass('overflow-hidden');
        }
    });

    //register form interest buttons
    var interests = [];
    $('body').on('click', '.interest', function (e) {
        var interest = $(this).attr('data-value');
        if ($(this).hasClass('selected')) {
            interests = interests.filter(function (value) {
                return value !== interest;
            });
            $(this).removeClass('selected');
        } else {
            interests.push(interest);
            $(this).addClass('selected');
        }
        //console.log(interests);
        if (interests.length) {
            $('.input_field_interest input').val(interests);
        } else {
            $('.input_field_interest input').val('');
        }
    });

    //main-menu-dropdown
    $('body').on('click', '.hd_menu .has_child_items', function () {
        if ($(this).hasClass('show_dropdown')) {
            if ($(this).hasClass('root-childs')) {
                $(this).removeClass('show_dropdown');
            } else {
                $('.has_child_items.show_dropdown').removeClass('show_dropdown');
            }
            if ($(this).next().find('.root-child-container').is(":visible") && $(window).width() < 768 || $(this).next().is(":visible") && $(window).width() < 768) {
                $('.root-child-container').slideUp();
            }
        } else {
            if ($('.has_child_items.show_dropdown').length) {
                if ($(this).closest('li').hasClass('dropdown') && $(this).hasClass('root-childs')) {
                    $('.has_child_items.show_dropdown').addClass('show_dropdown');
                    if ($(window).width() < 768) {
                        $(this).next().slideDown();
                    }
                } else {
                    $('.has_child_items.show_dropdown').removeClass('show_dropdown');
                    if ($(window).width() < 768) {
                        $('.root-child-container').slideUp();
                    }
                }
            }
            $(this).addClass('show_dropdown');
        }
    });
    //close dropdown on body click(not menu)
    var menu = $('.hd_menu_wrp');
    $('body').click(function (event) {
        var isMenuClick = $(event.target).closest(menu).length > 0;
        if (!isMenuClick && menu.find('.has_child_items.show_dropdown').length) {
            if ($(window).width() < 768) {
                $('.root-child-container').slideUp();
            }
            menu.find('.has_child_items.show_dropdown').removeClass('show_dropdown');
        }
    });


    //localization language 
    class LocalizationForm extends HTMLElement {
        constructor() {
            super();
            this.elements = {
                input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
            };
            this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
        }
        onItemClick(event) {
            event.preventDefault();
            const form = this.querySelector('form');
            console.log('adad', event.currentTarget);
            this.elements.input.value = event.currentTarget.dataset.value;

            console.log('1. Selected lang:' + event.currentTarget.dataset.value);

            window.Shopify.loadFeatures([
                {
                    name: 'consent-tracking-api',
                    version: '0.1',
                }
            ],
                function (error) {
                    if (error) {
                        throw error;
                    }

                    if (window.Shopify.customerPrivacy.preferencesProcessingAllowed()) {
                        setCookie(event.currentTarget.dataset.value);
                    }
                    if (form) form.submit();
                });


        }
    }
    customElements.define('localization-form', LocalizationForm);

    if (window.screen.width < 768) {
        $('body').on('click', '.language_wrp .dropdown_select', function () {
            $(this).closest('.dropdown_select_wrp').toggleClass('active');
            console.log('1. Selected lang:' + this);
        });
        let lang = $('.language_wrp');
        $('body').click(function (event) {
            let islangClick = $(event.target).closest(lang).length > 0;
            if (!islangClick && lang.find('.dropdown_select_wrp.active').length) {
                lang.find('.dropdown_select_wrp.active').removeClass('active');
            }
        });
    }

    //close sortby on body click
    let sortbydrop = $('.filter-select');
    $('body').click(function (event) {
        let issortClick = $(event.target).closest(sortbydrop).length > 0;
        if (!issortClick && sortbydrop.find('.custome_dropdown_select.open').length) {
            sortbydrop.find('.custome_dropdown_select.open').removeClass('open');
        }
    });


    $('body').on('click', '.predictive-btn', function (e) {
        e.preventDefault();
        $(this).closest('predictive-search').find('form').submit();
    });

    //collection filter button position
    function add_height_button() {
        let header_height = $('#shopify-section-header').height();
        let banner_height = $('.collection_banner').height();
        let total_height = header_height + banner_height;
        $('.collection_menu_icon').css('top', total_height + 'px');
        $('.collection_menu_icon').css('display', 'flex');
    }
    if ($('.collection_menu_icon').length && window.screen.width > 767) {
        add_height_button();
    }

});


$('.nice-select').each(function () {
    var select = $(this),
        name = select.attr('name');
    select.hide();
    select.wrap('<div class="nice-select-wrap"></div>');
    var parent = select.parent('.nice-select-wrap');
    parent.append('<ul id=' + name + ' style="display:none"></ul>');
    select.find('option').each(function () {
        var option = $(this),
            value = option.attr('value'),
            label = option.text();
        if (option.is(":first-child")) {
            $('<a href="#" class="drop">' + label + '</a>').insertBefore(parent.find('ul'));
        } else {
            parent.find('ul').append('<li><a href="#" id="' + value + '">' + label + '</a></li>');
        }
    });
    parent.find('a').on('click', function (e) {
        parent.toggleClass('down').find('ul').slideToggle(300);
        e.preventDefault();
    });
    parent.find('ul a').on('click', function (e) {
        var niceOption = $(this),
            value = niceOption.attr('id'),
            text = niceOption.text();
        select.val(value);
        parent.find('.drop').text(text);
        e.preventDefault();
    });
});
